import {Action} from "../../data/ActionTypes";

const initialState = {

   discount_margin: [],
   service_prices: [],
   part_prices: [],

   edit: 0,

   margin: 0,
   title: '',
   margin_type: 1,
   deleted: false,

   list_type_margin: [
      {
         id: 2,
         title: 'Наценка на товары'
      },{
         id: 1,
         title: 'Скидка на работы'
      }
   ],

   showDeleted: false,
   filter_type: null,
   page: 0
}
 
export const priceReducer = (state = initialState, action) => {
   switch (action.type){

      case  Action.Price.CHANGE_STATE: {
         return {...Object.assign(state, action.data)}
      }
 

      case Action.Price.EDIT: {
         return {
            ...state, 
            edit: action.price.id,

            margin: action.price.margin,
            title: action.price.title,
            margin_type: action.price.margin_type,
            deleted: action.price.deleted,
         }
      }
 
      case Action.Price.RESET: {
         return {
            ...state, 
            edit: 0,

            margin: 0,
            title: '',
            margin_type: 0,
            deleted: false
         }
      }

      default: return state
   }
    
}
 